import React, { useReducer } from 'react'

interface PaymentState {
  status: 'idle' | 'in progress' | 'success' | 'failed',
  error: string | null
}

interface Action {
  type: 'start' | 'success' | 'fail' | 'reset',
  error: string | null
}

const paymentInitialState: PaymentState = { status: 'idle', error: null }
const paymentReducer = (state: PaymentState, action: Action): PaymentState => {
  switch (action.type) {
    case 'start':
      return { status: 'in progress', error: null }
    case 'success':
      return { status: 'success', error: null }
    case 'fail':
      return { status: 'failed', error: action.error }
    default:
      return { status: 'idle', error: null }
  }
}
export type DispatchPaymentStatus = React.Dispatch<Action>
export const usePaymentStatus = ():
{ paymentStatus: PaymentState['status'],
  dispatchPaymentStatus: React.Dispatch<Action>,
  helpMessage: string } => {
  const [paymentStatusState, dispatchPaymentStatus] = useReducer(
    paymentReducer,
    paymentInitialState,
  )
  let helpMessage = ''
  switch (paymentStatusState.status) {
    case 'in progress':
      helpMessage = 'Processing your payment'
      break
    case 'failed':
      helpMessage = paymentStatusState.error ?? ''
      break
    default:
      helpMessage = ''
      break
  }
  return { paymentStatus: paymentStatusState.status, dispatchPaymentStatus, helpMessage }
}
